<template>
    <jet-section>
        <template #title>
            Payments & Withdrawals
        </template>
        <template #description>
            Your deposits and withdrawals.
        </template>
        <template #content>
            <div class="overflow-scroll  shadow border-b border-gray-200 transition duration-500 ease-in-out dark:border-gray-800 sm:rounded-lg" v-if="user.payments.length"
            :class="user.payments.length > 7 ? user.payments.length:''">
                <table class="min-w-full divide-y divide-gray-200" v-if="user.payments.length">
                    <thead class="bg-gray-50 bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900">
                        <tr>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Reference
                            </th>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Type
                            </th>
                            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Amount
                            </th>
                            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Transaction Date
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200">
                        <tr v-for="(payment, paymentKey) in user.payments" :key="paymentKey" :class="paymentKey % 2 === 0 ? 'bg-white transition duration-500 ease-in-out dark:bg-gray-600' : 'bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-800'" class="dark:hover:bg-opacity-80">
                            <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm  text-left text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                    {{ payment.reference }}

                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white text-left">
                                <div class="text-sm text-left font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                    {{ payment.type }}
                                </div>
                            </td>
                            <td class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white">{{ formatter.format(payment.amount / 100) }}</div>
                            </td>
                            <td class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white">{{ moment(payment.created_at).format('dddd, MMMM Do, YYYY') }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <alert type="info" class="mt-4">
                    <template #title>
                        No payments Available!
                    </template>
                    <template #message>
                        You haven't made your first payment yet.
                    </template>
                </alert>
            </div>
        </template>
    </jet-section>
</template>
<script>
import { computed } from 'vue'
import JetSection from '@/Jetstream/Section.vue'
import JetButton from '@/Jetstream/Button.vue'
import TwTable from '@/Global/Elements/TwTable.vue'
import RacingStarsIcon from '@/Global/RacingStarsIcon'
import Alert from '@/Global/Alert.vue'
import moment from 'moment'

export default {
    components: {
        JetSection,
        JetButton,
        TwTable,
        RacingStarsIcon,
        Alert,
    },

    props: {
        user: Object,
    },

    setup(props) {
        /**
         * Formatter function required to format currencies/prices correctly.
         *
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        return {
            formatter,
            moment,
        }
    }
}

</script>
